module.exports = __webpack_public_path__ + "static/media/11import-27.f56b43ff.xlsx";